
		<!-- Navbar Toggler -->
		<!-- (click)="leftSidebar.toggleSideBar()" -->
		<button pmd-btn pmdRipple pmd-btn-fab pmd-btn-flat size="xs"
			(click)="toggleSideBar()"
			class="pmd-sidebar-toggle d-xl-none pmd-btn-rounded" 
			aria-label="Press enter to open the left sidebar navigation">
			<i class="material-icons-round md-light">menu</i>
		</button>
		<!-- Navbar brand -->

		<div class="d-flex d-sm-none">
			<img src="assets/images/kanz-icon.png" class="fils-logo-icon" alt="PayKanz" height="40">
		</div>

		<div class="d-flex align-items-center d-none d-sm-flex"> 
			<button type="button" *ngIf="headerData.currentModule !=''" (click)="backClicked()" pmdRipple pmd-btn-fab color="primarylight" size="sm" class="me-3">
				<i class="material-icons material-symbols-rounded pmd-icon-sm">arrow_back</i>
			</button>
			<div >
				<ng-container *ngIf="headerData.currentTitle !=''">
					<h1 tabindex="0" class="mb-0 text-white h3">{{headerData.currentTitle}}</h1>
				</ng-container>
				<ng-container *ngIf="headerData.currentTitle == undefined || headerData.currentTitle ==''">
					<h1 tabindex="0" class="mb-0 text-white h3" *ngIf="headerData.invoiceNumber!=undefined">{{headerData.currentPage}} ({{headerData.invoiceNumber}})</h1>
					<h1 tabindex="0" class="mb-0 text-white h3" *ngIf="headerData.invoiceNumber==undefined">{{headerData.currentPage}}</h1>
				</ng-container>
				
				<nav *ngIf="headerData.currentPage != 'Dashboard'" aria-label="breadcrumb" class="breadcrumb mb-0">
					<ul class="breadcrumb pmd-breadcrumb pmd-breadcrumb-dark">
						<li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard">Dashboard</a></li>
						<li class="breadcrumb-item" *ngIf="headerData.currentModule !=''"><a href="javascript:void(0)" routerLink="{{headerData.currentModulePath}}">{{headerData.currentModule}}</a></li>
						<li class="breadcrumb-item active" aria-current="page" tabindex="0">{{headerData.currentPage}}</li>
					</ul>
				</nav>
			</div>
		</div>

		<pmd-navbar-right-icon class="d-flex align-items-center pf-navbar-right-icon">
			<!-- <button type="button" pmdRipple pmd-btn-fab pmd-btn-raised color="primarylight" class="d-none d-sm-block" size="sm">
				<i class="material-icons material-symbols-rounded pmd-icon-sm">search</i>
			</button> -->

			


			<div class="dropdown me-0 pmd-dropdown pmd-notification-dropdown ms-auto" pmdDropdown >
				<a (click)="getNotificationList()" href="javascript:void(0);" pmd-btn-fab pmd-btn-raised color="primarylight" pmdDropdownToggle size="sm" class="position-relative dropdown-toggle">
					<i class="material-symbols-rounded pmd-icon-sm">notifications</i>
					<!-- <span class="position-absolute top-0 mt-1 ms-1 translate-middle p-1 bg-warning border border-primary rounded-circle">
					  <span class="visually-hidden">New alerts</span>
					</span> -->
					<span *ngIf="notificationObj.message.count > 0" class="pmd-notification-count-badge position-absolute top-0 mt-1 ms-0 start-100 translate-middle badge border border-primary rounded-circle bg-warning">
						<!-- {{notificationObj.message.count}}  -->
						<span class="visually-hidden">unread messages</span>
					</span>
				</a>
				<div class="dropdown-menu notification-dropdown dropdown-menu-right" *pmdDropdownMenu
						aria-labelledby="notificationDropdown">
						<div _ngcontent-wwn-c34="" class="arrow"></div>
						<div class="dropdown-menu-title bg-dark">
							<h2 class="mb-0 text-white h4">Notifications</h2>
						</div>
						<div class="list-group pmd-list pmd-list-border scrollbar" *ngIf="notificationObj.message.count > 0">
							<ng-container *ngFor="let message of this.notificationObj.message.message">
								<a (click)="redirectToUrl(message)" class="list-group-item d-flex flex-row unread" tabindex="0">
									<div class="pmd-avatar pmd-avatar-primary me-3" aria-hidden="true">
										<i class="material-icons material-symbols-rounded" aria-hidden="true">demography</i>
									</div>
									<div class="flex-grow-1">
										<h6 class="pmd-list-title">{{message.notification}}</h6>
										<p class="pmd-list-subtitle">{{notificationTimeConvert(message.created_date)}}</p>
									</div>
								</a>
							</ng-container>
						</div>
						<div class="text-center my-md-5 py-5" [ngClass]="notificationObj.message.count > 0 ? 'd-none' :  ''">
							<div class="mb-3 pmd-avatar pmd-avatar-primary pmd-avatar-xl d-inline-flex" aria-hidden="true">
								<span class="material-icons material-symbols-rounded pmd-icon-md" aria-hidden="true">
									notifications
								</span>
							</div>
							<h1 class="h3">No Notifications Yet!</h1>
							<p>You have no notifications right now. <br>Come back later</p>
						</div>

						<!-- <button routerLink="/notifications" type="button" pmd-btn-outline pmd-btn pmd-btn-flat
							color="link" aria-label="Press enter to go to nofitication page for view all notification"
							class="pmd-btn-link pmd-link-dark">View All</button> -->
					</div>

			</div>

		
			<form  class="language-dropdown-form" style="pointer-events:none ;">
				<pmd-input-group-outline pmd-input-group-icon class="language-dropdown">
					<pmd-input-group-text>
						<i class="material-icons material-symbols-rounded md-light pmd-icon-sm">
							language
						</i>
					</pmd-input-group-text>
					<ng-select placeholder="Press Enter to select language"
						ariaLabel="Press Enter to select language" appearance="outline" [searchable]="false"
						pmdTextField [clearable]="false" labelForId="languageId" name="language"
						[(ngModel)]="language" (change)="changeLang()"
						class="pmd-select pmd-select-dark pmd-select-sm pmd-select-outline">
						<ng-option *ngFor="let l of languages" [value]="l.id">{{l.name}}</ng-option>
					</ng-select>
				</pmd-input-group-outline>
			</form>
			<div class="dropdown pmd-dropdown pmd-user-info" pmdDropdown>
				<button type="button" pmdDropdownToggle pmd-btn-fab pmd-btn-raised color="warning" size="sm" class="position-relative dropdown-toggle me-0">
					{{commonService.getStringFirstChar(userObj.firstname +" "+ userObj.lastname,1)}}
				</button>
				<ul class="dropdown-menu dropdown-menu-right" *pmdDropdownMenu aria-labelledby="userNavbarDropdown"
					role="menu">
					<li>
						<a class="dropdown-item d-flex align-items-center" routerLinkActive='active'
							routerLink="/profile" pmdRipple aria-label="Press enter to view profile"
							role="menuitem" tabindex="0">
							<span class="material-icons material-symbols-rounded me-2" aria-hidden="true">person</span>My Profile</a>
					</li>
					<li>
						<a  href="javascript:void(0)" class="dropdown-item d-flex align-items-center" routerLinkActive='active'
							pmdRipple aria-label="Press enter to logout from the tool"
							role="menuitem" tabindex="0" (click)="logout()">
							<span class="material-icons material-symbols-rounded me-2" aria-hidden="true">logout</span>Logout</a>
					</li>
				</ul>
			</div>
			

		</pmd-navbar-right-icon>